import React, { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Trans } from "react-i18next";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import "../user-pages/userpages.css";

const HelpButton = () => {
  const history = useHistory(); // Add this line to define `history`
  const location = useLocation();

  useEffect(() => {
    // Check if the URL matches the pattern
    const isChatPage = location.pathname.startsWith("/support/chat/");
    // Add a class to hide the Help button if on the chat page
    if (isChatPage) {
      document.querySelector(".help-dropdown")?.classList.add("hidden");
    } else {
      document.querySelector(".help-dropdown")?.classList.remove("hidden");
    }
  }, [location]);

  const { isDarkTheme } = useTheme();

  const dropdownItems = [
    {
      icon: "mdi mdi-file-document-outline",
      label: "Documents",
      link: "/document",
      isInternal: true, // internal link
    },
    {
      icon: "mdi mdi-help-circle-outline",
      label: "FAQ",
      link: "https://faq-arbitfx.com/",
      isInternal: false, // external link
    },

    {
      icon: "mdi mdi-book-open",
      label: "User Guide",
      link: "https://arbitfx-help.freshdesk.com/support/solutions",
      isInternal: false,
    },
    {
      icon: "mdi mdi-file-edit-outline",
      label: "Create Ticket",
      link: "/support",
      isInternal: true,
    },
  ];

  // Function to handle navigation on click
  const handleItemClick = (item) => {
    // Log the page title for User Guide
    if (item.label === "User Guide") {
      console.log("Current Page:", location.pathname);
      console.log("Navigating to:", item.label);
    }


    if (item.isInternal) {
      // Navigate to internal link
      history.push(item.link);
    } else {
      // Open external link in a new tab
      window.open(item.link, "_blank", "noopener,noreferrer");
    }
  }

  return (
    <Dropdown alignRight as="li" className="nav-item help-dropdown">
      <Dropdown.Toggle
        as="button"
        className="btn btn-primary position-fixed rounded-pill shadow"
        style={{
          bottom: "25px",
          right: "25px",
          zIndex: 1000,
          fontWeight: "500",
          fontSize: "18px",
          padding: "10px 20px",
        }}
      >
        Help
      </Dropdown.Toggle>

      <Dropdown.Menu
        className={`navbar-dropdown preview-list navbar-profile-dropdown-menu custom-dropdown-menu ${isDarkTheme ? "dark-dropdown-menu" : ""
          }`}
        style={{ minWidth: "180px" }}
      >
        {dropdownItems.map((item, index) => (
          <Dropdown.Item
            as={item.isInternal ? Link : "a"} // Render Link for internal or <a> for external
            to={item.isInternal ? { pathname: item.link } : undefined}
            href={!item.isInternal ? item.link : undefined}
            target={!item.isInternal ? "_blank" : undefined}
            rel={!item.isInternal ? "noopener noreferrer" : undefined}
            key={index}
            className="preview-item px-1 m-0"
            style={{
              textDecoration: "none",
              color: "inherit", // Ensure consistent text color
              display: "flex", // Align icon and text horizontally
              alignItems: "center", // Vertically align content
            }}
            onClick={() => handleItemClick(item)}
          >
            <div className="preview-thumbnail" style={{ marginRight: "0px" }}>
              <div className="preview-icon rounded-circle">
                <i
                  className={item.icon}
                  style={{ color: "#616F8C", fontSize: "20px" }}
                ></i>
              </div>
            </div>
            <div className="preview-item-content">
              <p
                className="preview-subject mb-1"
                style={{ whiteSpace: "pre-wrap", color: "#011638" }}
              >
                <Trans>{item.label}</Trans>
              </p>
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default HelpButton;
